import CmsTransformer from '~/components/cms/CmsTransformer';
import { CmsRowProps } from '~/types/Cms';

/**
 * A plain container for the blocks an editor grouped together — the editor uses it
 * inside a column to keep an image and its caption as one unit, so the children stack
 * the way they would on their own. The horizontal arrangement is the columns block's
 * job (`monsieurbiz.column`), not this one's.
 */
const CmsRow = ({ data }: CmsRowProps) => {
  return (
    <div className="cms-row">
      {data.content.map((block, index) => (
        <CmsTransformer item={block} key={index} />
      ))}
    </div>
  );
};

export default CmsRow;
